import { TFunction } from 'i18next';
export const paymentAgreementPolyllmDefault = (t: TFunction): string =>
  t('subscription:payment_form.agreement_polyllm-chat');
export const paymentAgreementPolyllmUs = (t: TFunction): string =>
  t('subscription:payment_form.agreement_polyllm-chat_us');
